/* eslint-disable no-undef */
import { onMounted } from 'vue'
import { useEnvironmentVariables } from '@/shared/composables/useEnvironmentVariables.js'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'
import { useDebugger } from '@/shared/composables/useDebugger.js'
import { useFeatureFlags } from '@/shared/composables/useFeatureFlags.js'

export const useBonjoroWidgetInitializer = () => {
  const { BONJORO_ENABLED } = useFeatureFlags()
  const { bonjoroAppId } = useEnvironmentVariables()
  const { isUserLoggedIn } = usePermissionSystem()
  const { currentUser } = useCurrentUser()
  const { $debug } = useDebugger()

  onMounted(() => {
    if (isUserLoggedIn.value && BONJORO_ENABLED.value) {
      bonjoro('create', bonjoroAppId.value)
      bonjoro('identify', currentUser.value.email, {
        userHash: currentUser.value.bonjoroIdentifyToken,
      })
      $debug('Data has been sent to Bonjoro widget')
    }
  })
}
